export class Amazon {
  public static post(method:string, command:string, params:any = null): Promise<{status:number, body?:any}> {
    return new Promise((resolve, reject)=>{
      var request = new XMLHttpRequest();
      const endpoints: Record<string, string> = {
        auth: 'https://ostfoxro5k.execute-api.eu-north-1.amazonaws.com/default/NR-Auth',
        races: 'https://a6a8nr0rte.execute-api.eu-north-1.amazonaws.com/Prod/v1/races',
        ivs: 'https://u289ipgzji.execute-api.eu-north-1.amazonaws.com/default/NR-IVS'
      };

      const endpoint = endpoints[method] || endpoints.auth;

      request.open('POST', endpoint);
      request.setRequestHeader('Content-Type', 'application/json');

      // request.setRequestHeader('Authorization', authorizationToken);
  
      let payload = {command};

      if(params) 
        payload = {command, ...params};

      let body = JSON.stringify(payload);

      console.log('> AWS /' + method, {
        payload,
        url: endpoint,
        headers: {
          'Content-Type': 'application/json'
        }
      });
      
      request.send(body);
  
      request.onload = () => {
        let body = null;
        if (request.responseText != '')
          body = JSON.parse(request.responseText);
  
        console.log('< AWS', {
          status: request.status,
          url: request.responseURL,
          body
        });
  
        resolve({
          status: request.status,
          body: body
        });
      };
  
      request.onerror = (e) => {
        console.log('<== ERROR');
        resolve({
          status: 500,
          body: {message: 'Internal service error!'}
        });
      };
    });
  }
}